import React, { Fragment } from "react"
//import { Link } from "gatsby"
import Skills from "../components/skills/skills"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PageTitle from "../components/page-title/page-title"

const pageHeading = "About Ken Walton"
const pageSubHeading = `For the last 5 years, I've worked as a front-end developer at
Stanley Black & Decker on websites and applications for
Craftsman, Dewalt, Irwin, Lennox, Stanley, Black +
Decker, Porter Cable, Bostitch, Mac Tools, and Proto Industrial.`

const pageBody = {
  pageBodySections: [
    {
      pageBodySection: {
        pageBodySectionHead: "What do I do at work?",
        pageBodySectionBody: [
          `In IT, there are 2 sides of application services, build and run.
        I am on the build side, which is developing new sites
        and applications. I lead, mentor and work as a hands-on developer
        alongside a team of front-end developers, largely off-shore
        contractors using a staff augmentation model, to develop modular,
        reusable code.`,
          `Our tooling consists of Gulp as a task runner, Handlebars or Pug for
          <strong>HTML</strong> templating, lazy-loading
          <strong>JavaScript</strong> delivered using Webpack,
          <strong>CSS</strong> written with SASS, with code repositories in
          GIT. I understand how build and delivery pipelines work as we work
          with Azure DevOps.`,
          `I started on the run side which helped me learn the basics of
          software development in an enterpise level environment. I learned to
          structure code to scale and be reusable, how to trouble shoot tricky
          JavaScript errors from dev instances to production environments, the
          concepts of continuous integration and continuous delivery and
          working in an Agile environment performing maintenance and
          enhancement work.`,
          `Maintenance is things like bug fixes, accessibility issues and other
          small tweaks. Enhancement work is adding new features or significant
          rewrites of an existing feature. Some of the most fun I had was
          working with our back-end developers on website enhancements. A few
          of those back-end devs were excellent teachers which contributed to
          my education as a developer.`,
        ],
      },
    },
    {
      pageBodySection: {
        pageBodySectionHead:
          "What about before I became a front-end developer?",
        pageBodySectionBody: [
          `For ten years prior to becoming a front-end developer, I had worked
        in educational publishing, specializing in the K–12 educational
        market on both interactive and print projects. Going back even
        further, I designed catalogs, e-mail campaigns, and websites after
        getting my start in the advertising specialty business.`,
        ],
      },
    },
  ],
}

const buildPageBodySection = () => {
  let bodySections = pageBody.pageBodySections.map((section, i) => {
    // this knows there are 4 paragraphs in item 1 and 1 in item 2
    //console.log(section.pageBodySection.pageBodySectionBody.length)
    //console.log(section.pageBodySection.pageBodySectionHead)

    let bodySection = section.pageBodySection.pageBodySectionBody.map(
      (paragraph, j) => {
        console.log(paragraph)
        return (
          <p
            key={"a" + j}
            dangerouslySetInnerHTML={{ __html: paragraph }}
            className="fade-in"
          ></p>
        )
      }
    )

    return (
      <Fragment>
        <h3 key={i} className="fade-in">
          {section.pageBodySection.pageBodySectionHead}
        </h3>
        {bodySection}
      </Fragment>
    )
  })

  return bodySections
}

const AboutPage = () => (
  <Layout>
    <SEO title="About" />

    <article className="about">
      <div className="about-head">
        <div className="container">
          <PageTitle pageHeading={pageHeading} />
        </div>
      </div>

      <div className="about-intro">
        <div className="container">
          <h2 className="fade-in">{pageSubHeading}</h2>
        </div>
      </div>

      <div className="about-body">
        <div className="container">
          <Skills />
          {buildPageBodySection()}
        </div>
        <div className="container"></div>
      </div>
    </article>
  </Layout>
)

export default AboutPage
